import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer.jsx';
import { useTranslation } from '../hooks/useTranslation.js';
import { localizePath } from '../utils/localizedRoutes.js';
import { applyPageSeo } from '../utils/seo.js';
import siteConfig from '../seo/siteConfig.cjs';

const SeoLandingPage = ({ pageId }) => {
  const { currentLang } = useTranslation();
  const seo = siteConfig.getPageSeo(pageId, currentLang);
  const relatedPageIds = siteConfig.getRelatedPageIds(pageId).filter((relatedPageId) => relatedPageId !== pageId);
  const copy = siteConfig.getLocalizedCopy(currentLang);

  useEffect(() => {
    applyPageSeo(seo, currentLang);
  }, [seo, currentLang]);

  return (
    <div className="min-h-screen bg-bg-main text-text-primary">
      <main className="site-main">
        <section className="site-hero site-hero--single">
          <div className="site-hero__copy">
            <div className="editorial-kicker mb-4">pAIoneer Labs GmbH</div>
            <h1 className="site-title">{seo.h1}</h1>
            <p className="site-lead">{seo.lead}</p>
          </div>
        </section>

        {seo.sections?.map((section, sectionIndex) => (
          <section className="signal-section" key={sectionIndex}>
            <header className="signal-section-header">
              <h2>{section.title}</h2>
            </header>
            <div className="signal-service-list">
              {section.items?.map((item, index) => (
                <article className="signal-service-row" key={index}>
                  <div>
                    <h3>{seo.h1}</h3>
                    <p>{item}</p>
                  </div>
                </article>
              ))}
            </div>
          </section>
        ))}

        <section className="signal-section">
          <header className="signal-section-header">
            <h2>{copy.relatedTitle}</h2>
          </header>
          <div className="signal-service-list">
            {relatedPageIds.map((relatedPageId) => {
              const relatedSeo = siteConfig.getPageSeo(relatedPageId, currentLang);
              return (
                <article className="signal-service-row" key={relatedPageId}>
                  <div>
                    <h3>{relatedSeo.h1}</h3>
                    <p>{relatedSeo.description}</p>
                  </div>
                  <Link to={localizePath(`/${relatedSeo.slug}`, currentLang)}>{relatedSeo.h1}</Link>
                </article>
              );
            })}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default SeoLandingPage;
